"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCustomWindowObject = exports.getCustomWindowObject = void 0;
const getCustomWindowObject = (windowVariableKey) => {
    return windowVariableKey.split('.').reduce((cur, key) => cur[key], window);
};
exports.getCustomWindowObject = getCustomWindowObject;
const setCustomWindowObject = (path, value) => {
    const pList = path.split('.');
    const key = pList.pop();
    const pointer = pList.reduce((accumulator, currentValue) => {
        if (accumulator[currentValue] === undefined)
            accumulator[currentValue] = {};
        return accumulator[currentValue];
    }, window);
    pointer[key] = value;
    return window;
};
exports.setCustomWindowObject = setCustomWindowObject;
//# sourceMappingURL=window.util.js.map